export default "__VITE_ASSET__dTHXKICW__"